import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Stack, Badge, Form } from "react-bootstrap";
import { RequestService } from "../../../HttpService/RequestService";
import Placeholder from 'react-bootstrap/Placeholder';
import { MdVisibility, MdLocationOn, MdGrid3X3, MdCircle, MdDelete, MdAirportShuttle, MdAirplaneTicket, MdAirplanemodeActive, MdOutlineWater, MdDirectionsBoat, MdRailwayAlert, MdAddRoad, MdHouseboat, MdTrain, MdDeleteOutline } from "react-icons/md";
import Swal from 'sweetalert2'
import dateFormat from "dateformat";
import { FaDatabase, FaCalendar } from "react-icons/fa";
import { HiLocationMarker } from "react-icons/hi";
import { TODIS_DROPDOWN } from "../../../components/Forms";
import { TODIS_BTN_PRIMARY, TODIS_BTN_SECUNDARY, TODIS_YEAR_PICKER, TODIS_DATEPICKER } from "../../../components/Buttons";
import { BsGeoAlt, BsGrid, BsGridFill, BsSortDownAlt, BsArrowClockwise, BsCloudSlashFill, BsCheck, BsPersonCircle, BsX, BsSortDown } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { AuxiliaryService } from "../../../HttpService/AuxiliaryService";
import 'sweetalert2/src/sweetalert2.scss'
import style from "./Requests.module.scss";
import "../../DataCollection/style.css";
import SectionRequests from "./SectionRequests/SectionRequests";
import AuthContext from '../../../auth/authContext';



const Requests = ({ permissions }) => {

    const { user } = useContext(AuthContext);
    const [allRequests, setAllRequests] = useState(false);
    const [isEuAcquis, setIsEuAquis] = useState(false)
    const [euSectors, setEuSectors] = useState([])
    const [sectors, setSectors] = useState([])


    const handleAllRequestsChange = (event) => {
        setAllRequests(event.target.checked);
    };


    function getProjectTitle(transportType, regionalPartner, projectType) {
        const transportTypeTranslations = {
            'Roads': 'Road',
            'Railways': 'Railway',
            'Inland waterways': 'Inland Waterway',
            'Airports': 'Airport',
            'Railways Border Crossings': 'Railway Border Crossing',
            'Roads Border crossing': 'Road Border Crossing',
            'Seaports': 'Seaport',
            'Inland waterway ports': 'Inland Waterway Port'
        };
    
        if (transportType === 'Roads' || transportType === 'Railways' || transportType === 'Inland waterways') {
            if (projectType === 'TEN-T Projects') {
                return `${getSingularTransportType(transportType)} Project in ${regionalPartner}`;
            } else if (projectType === 'TEN-T Network performance monitoring') {
                return `${getSingularTransportType(transportType)} Section in ${regionalPartner}`;
            }
        } else if (projectType === 'EU Acquis') {
            return `${projectType} in ${regionalPartner}`;
        } else if (
            (transportType === 'Airports' || transportType === 'Seaports' || transportType === 'Inland waterway ports' || transportType == 'Freight Terminals') && projectType === 'TEN-T Projects') {
            return `${getSingularTransportType(transportType)} Project in ${regionalPartner}`;
        } else {
            return `${getSingularTransportType(transportType)} in ${regionalPartner}`;
        }

        function getSingularTransportType(type) {
            return transportTypeTranslations[type] || type;
        }
    }

    const navigate = useNavigate();

    const [order, setOrder] = useState(false)
    //const [filterR, setFilterR] = useState({ "Status": [], "Regional Partner": [], "Type": [], "Years": [] });
    const [filterR, setFilterR] = useState({ "Status": [], "Regional Partner": [], "Type": [], "Years": null, "Sector": [], "Eu Sector": [], "transportType": []})
    const [filter, setFilter] = useState({})
    const [requests, setRequestsR] = useState([])
    const [status, setStatus] = useState([
        {
            idAuxtabledetail: "1",
            txtDescription: "PENDING"
        },
        {
            idAuxtabledetail: "2",
            txtDescription: "WORKINGON"
        },
        {
            idAuxtabledetail: "3",
            txtDescription: "DONE"
        }
    ])
    const [type, setType] = useState([])
    const [regionals, setRegionals] = useState([])
    const [responseR, setResponse] = useState(false)
    const [tasksNotFound, setTasksNotFound] = useState(false)

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const statusClass = (status) => {

        if (status == "PENDING")
            return "#F4D35A";
        else if (status == "WORKINGON")
            return "#004494";
        else if (status == "DONE")
            return "#3db73d"
    }

    const getDataSelect = async () => {
        try {
            const auxiliaries = await new AuxiliaryService("auxData/typeform,regionalpartner,typetransport,tentcategory,euacquis,regulatoryarea").getAuxiliaries();

            auxiliaries.map(item => {
                if (item.txtNameTable == "typeform")
                    setType(item.auxtableDetailsDTOList)
                if (item.txtNameTable == "regionalpartner") {
                    let list = item.auxtableDetailsDTOList.sort((a, b) =>
                        a.txtDescription.localeCompare(b.txtDescription));
                    setRegionals(list)
                }
                if (item.txtNameTable == "typetransport")
                    setSectors(item.auxtableDetailsDTOList)
                if (item.txtNameTable == "euacquis")
                    setEuSectors(item.auxtableDetailsDTOList)
            })
        } catch (error) {
            console.log("error listing selects", error);
        }
    }

    const getRequests = async (filter) => {
        try {
            const response = await new RequestService("workflow/requests").getRequests(filter, user.username, allRequests);
            return response;


        } catch (error) {
            console.log("error listing requests", error);
        }
    }

/*

    const handleYear = (value) => {
        console.log("Selected year value:", value); // Verifica qué se está pasando como año
        console.log("filter pre: ",  filter);
        console.log("filterR pre: ",  filterR);
        if (value !== null && (typeof value === 'string' || typeof value === 'number')) {
            setFilterR(prevState => {
                const newValue = { ...prevState };
    
                if (!Array.isArray(newValue["Years"])) {
                    newValue["Years"] = []; // Inicializa como un array si no lo es
                }
    
                if (!newValue["Years"].includes(value)) {
                    newValue["Years"].push(value);
                }
    
                return newValue;
            });
    
            // Actualiza el objeto `filter` con el año seleccionado
            setFilter(prevState => {
                const newValue = { ...prevState };
                if (!newValue["Years"]) {
                    newValue["Years"] = [value];
                } else {
                    if (!newValue["Years"].includes(value)) {
                        newValue["Years"].push(value);
                    }
                }
                return newValue;
            });
        } else {
            console.error("Invalid value type for year:", value); // Log para verificar
        }
        console.log("filter post: ",  filter);
        console.log("filterR post: ",  filterR);
    };
*/
    const handleDate = (value, name) => {
        setFilterR(prevState => {
            const newValue = { ...prevState };
            newValue[name] = value;
            return newValue
        })
        const dateRange = value.split(' ~ ')
        setFilter(prevState => {
            const newValue = { ...prevState };
            newValue["fromDate"] = dateRange[0];
            if (dateRange[1]) {
                newValue["toDate"] = dateRange[1];
            } else {
                delete newValue["toDate"]
            }
            return newValue
        })
    }


/*
    const removeFilterYear = (year) => {
        setFilterR(prevState => {
            const newValue = { ...prevState };
            newValue["Years"] = newValue["Years"].filter(y => y !== year);
            return newValue;
        });
    
        
        setFilter(prevState => {
            const newValue = { ...prevState };
            if (newValue["Years"]) {
                newValue["Years"] = newValue["Years"].filter(y => y !== year);
                if (newValue["Years"].length === 0) {
                    delete newValue["Years"];
                }
            }
            return newValue;
        });
    };
*/
/*
const handleSelectR = (value, e, name, id) => {
    if (!filterR[name].some(item => item.name == e.target.text)) {
        setFilterR(prevState => {
            const newValue = { ...prevState };
            newValue[name] = [...newValue[name], { id: value, name: e.target.text }]
            return newValue
        })
        setFilter(prevState => {
            const newValue = { ...prevState };
            if (newValue[id] == undefined) {
                newValue[id] = [value]
            } else {
                newValue[id].push(value)
            }
            return newValue
        })
    } else {
        Toast.fire({
            icon: 'warning',
            title: "Filter by " + name + " <b>" + e.target.text + "</b> is already applied"
        })
    }
}

    const handleSelectS = (value, e, name, id) => {
        if (name == "Type" && value == 86) {
            console.log("changing the filterR here", name, value)
            setIsEuAquis(true);
            if (filterR["Type"].length > 0) {
                filterR["Type"].map(itm => { if (itm.id != 86) removefilterR("Type", "types", itm.id) })
            }
            if (filterR["TENT Category"].length > 0) {
                filterR["TENT Category"].map(itm => removefilterR("TENT Category", "tentCategories", itm.id))
            }
            if (filterR["Sector"].length > 0) {
                filterR["Sector"].map(itm => removefilterR("Sector", "sectors", itm.id))
            }

        } else {
            if (name == "Type" && value != 86) {
                setIsEuAquis(false);
                if (filterR["Type"].length > 0) {
                    filterR["Type"].map(itm => { if (itm.id == 86) removefilterR("Type", "types", itm.id) })
                }
                if (filterR["Eu Sector"].length > 0) {
                    filterR["Eu Sector"].map(itm => removefilterR("Eu Sector", "eu_sectors", itm.id))
                }
            }

        }
        if (!filterR[name].some(item => item.name == e.target.text)) {
            setFilterR(prevState => {
                const newValue = { ...prevState };
                newValue[name] = [...newValue[name], { id: value, name: e.target.text }]
                return newValue
            })
            setFilter(prevState => {
                const newValue = { ...prevState };
                if (newValue[id] == undefined) {
                    newValue[id] = [value]
                } else {
                    newValue[id].push(value)
                }
                return newValue
            })

        } else {
            Toast.fire({
                icon: 'warning',
                title: "Filter by " + name + " <b>" + e.target.text + "</b> is already applied"
            })
        }
    }
*/

    const handleSelectS = (value, e, name, id) => {
        // Verificación para el caso específico del filtro "Type" con valor 86
        if (name == "Type" && value == 86) {
            setIsEuAquis(true);
            if (filterR["Type"].length > 0) {
                filterR["Type"].forEach(itm => {
                    if (itm.id != 86) removefilterR("Type", "types", itm.id);
                });
            }
            if (filterR["Sector"].length > 0) {
                filterR["Sector"].forEach(itm => removefilterR("Sector", "sectors", itm.id));
            }
        } else if (name == "Type" && value != 86) {
            setIsEuAquis(false);
            if (filterR["Type"].length > 0) {
                filterR["Type"].forEach(itm => {
                    if (itm.id == 86) removefilterR("Type", "types", itm.id);
                });
            }
            if (filterR["Eu Sector"].length > 0) {
                filterR["Eu Sector"].forEach(itm => removefilterR("Eu Sector", "eu_sectors", itm.id));
            }
        }

        // Lógica compartida para agregar elementos al filtro si no existen
        if (!filterR[name].some(item => item.name == e.target.text)) {
            setFilterR(prevState => {
                const newValue = { ...prevState };
                newValue[name] = [...newValue[name], { id: value, name: e.target.text }];
                return newValue;
            });
            
            setFilter(prevState => {
                const newValue = { ...prevState };
                if (newValue[id] == undefined) {
                    newValue[id] = [value];
                } else {
                    newValue[id].push(value);
                }
                return newValue;
            });
        } else {
            Toast.fire({
                icon: 'warning',
                title: "Filter by " + name + " <b>" + e.target.text + "</b> is already applied"
            });
        }
    };


    const removefilterR = (name, id, value) => {
        setFilterR(prevState => {
            const newValue = { ...prevState };
            newValue[name] = newValue[name].filter(item => item.id != value)
            return newValue
        })
        setFilter(prevState => {
            const newValue = { ...prevState };
            newValue[id] = newValue[id].filter(item => item != value)
            if (newValue[id].length == 0)
                delete newValue[id]
            return newValue
        })
    }

    const removeFilterDate = (name) => {
        setFilterR(prevState => {
            const newValue = { ...prevState };
            newValue[name] = null
            return newValue
        })

        setFilter(prevState => {
            const newValue = { ...prevState };
            delete newValue["fromDate"]
            delete newValue["toDate"]
            return newValue
        })
    }

    const orderRequest = (order) => {
        setOrder(!order)
        setRequestsR(prevState => {
            let newState = [...prevState];

            return newState.sort(function (x, y) {
                if (order)
                    return y.id - x.id;
                else
                    return x.id - y.id;
            });
        }
        );
    }

    const deleteRequest = async (id) => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                Swal.fire({
                    title: 'Processing...',
                    text: 'Please wait while we process your request.',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });                    
                let res = await new RequestService("workflow/request/" + id).deleteRequests();
                    if (res.status == 200) {
                        Swal.close();
                        // Recargamos parcial (componente)
                        // Swal.close - - - Modificamos este swal para añadir espera logica
                        setRequestsR((prevState) => {
                            let newState = [...prevState]
                            newState = newState.filter(item => item.id != id)
                            return newState;
                        })
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Deleted!',
                            text: 'The request has been deleted.',
                            showConfirmButton: true
                        });
                    }
                }
            })
        } catch (error) {
            Swal.close();
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'An unexpected error occurred while creating the update request.',
                showConfirmButton: true
            });
            console.log("error in delete Request", error);
        }
    }

    const refreshRequest = async () => {
        setOrder(false)
        setResponse(false);
        let res = await getRequests(null, user.username, allRequests);
        if (res) {
            setRequestsR(prevState => {
                return res.sort(function (x, y) {
                    return y.id - x.id;
                });
            });
            setResponse(true);
        } else {
            setTasksNotFound(true);
        }
    }

    const removeAllFilterR = () => {
        setFilterR({ "Status": [], "Regional Partner": [], "Type": [], "Date": null, "Sector": [], "Eu Sector": [], "transportType": [] });
        setFilter({});
    }
    
/*
    useEffect(() => {
        (async () => {
            setResponse(false)
            let res = await getRequests(filter, user.username, allRequests);
            if (res) {
                setRequestsR(prevState => {
                    return res.sort(function (x, y) {
                        return y.id - x.id;
                    });
                });
                setResponse(true);
            } else {
                setTasksNotFound(true);
            }
        })();
    }, [filter]);
*/

useEffect(() => {
    const convertFilterValues = () => {
        const newFilter = { ...filter };

        // Convertir fechas "fromDate" y "toDate" si son del tipo "YYYY"
        if (newFilter.fromDate && /^\d{4}$/.test(newFilter.fromDate)) {
            newFilter.fromDate = `01/01/${newFilter.fromDate}`;
        }
        if (newFilter.toDate && /^\d{4}$/.test(newFilter.toDate)) {
            newFilter.toDate = `31/12/${newFilter.toDate}`;
        }

        // Si "fromDate" está lleno y "toDate" es nulo, asignar el fin del año de "fromDate" a "toDate"
        if (newFilter.fromDate && !newFilter.toDate) {
            const yearFromDate = newFilter.fromDate.split('/')[2]; // Extrae el año de "fromDate"
            newFilter.toDate = `31/12/${yearFromDate}`;
        }

        // Si "Sector" tiene valores, los pasamos a "Project Type"
        if (newFilter["sectors"] && newFilter["sectors"].length > 0) {
            if (!newFilter["transportType"]) {
                newFilter["transportType"] = [];
            }
            // Añadimos los valores de "Sector" a "Project Type"
            newFilter["transportType"] = [...newFilter["transportType"], ...newFilter["sectors"]];
            // Limpiamos el campo "Sector"
            delete newFilter["sectors"];
        }

        // Si "Eu Sector" tiene valores, los pasamos a "Project Type"
        if (newFilter["eu_sectors"] && newFilter["eu_sectors"].length > 0) {
            if (!newFilter["transportType"]) {
                newFilter["transportType"] = [];
            }
            // Añadimos los valores de "Eu Sector" a "Project Type"
            newFilter["transportType"] = [...newFilter["transportType"], ...newFilter["eu_sectors"]];
            // Limpiamos el campo "Eu Sector"
            delete newFilter["eu_sectors"];
        }
        return newFilter;
    };


    (async () => {
        setResponse(false);

        // Convierte los valores antes de hacer la solicitud
        const modifiedFilter = convertFilterValues();
        let res = await getRequests(modifiedFilter, user.username, allRequests);
        if (res) {
            setRequestsR(prevState => {
                return res.sort((x, y) => y.id - x.id);
            });
            setResponse(true);
        } else {
            setTasksNotFound(true);
        }
    })();
}, [filter]);



    useEffect(() => {
        (async () => {
            await getDataSelect();
        })();
    }, []);

    return (
        <>
            <Col xxl={6} xl={6} lg={12} md={12} sm={12}>
                <Container fluid className="todis-form-wrapper p-4" style={{ height: '95%' }}>
                    <Row className="todis-form-action-panel pb-3">
                        <Col lg={2} className="ps-4" >
                            <Stack gap={0}>
                                <h4 className="todis-header" style={{ fontSize: '20px' }}>Requests</h4>
                            </Stack>
                        </Col>
                        <Col lg={10}>
                                <Row className="float-end">
                                <Row className="task-att py-3">
    <Col lg={4} className={style.title}><strong>Load all requests:</strong></Col>
    <Col lg={8}>
        <Form.Check
            type="switch"
            id="loadAllRequests"
            label={allRequests ? "Yes" : "No"}
            checked={allRequests}
            onChange={handleAllRequestsChange}
        />
    </Col>
</Row>

{/* Primera hilera */}
<Row className="mb-2" style={{ gap: '10px 0' }}>
    <Col lg={2} style={{ width: 'auto' }}>
        <TODIS_DROPDOWN title="Regional Partner" handleSelect={(e, evt) => handleSelectS(e, evt, "Regional Partner", "regionalPartner")} response={responseR} items={regionals} icon={BsGeoAlt} />
    </Col>
    <Col lg={2} style={{ width: 'auto' }}>
        <TODIS_DROPDOWN title="Status" handleSelect={(e, evt) => handleSelectS(e, evt, "Status", "status")} response={responseR} items={status} icon={BsGridFill} />
    </Col>
    <Col lg={2} style={{ width: 'auto' }}>
        <TODIS_DROPDOWN title="Module" handleSelect={(e, evt) => handleSelectS(e, evt, "Type", "projectType")} response={responseR} items={type} icon={BsGrid} />
    </Col>
</Row>

{/* Segunda hilera */}
<Row className="mb-2" style={{ gap: '10px 0' }}>
    <Col lg={6}>
        {isEuAcquis ? (
            <TODIS_DROPDOWN title="EU ACQUIS SECTOR" handleSelect={(e, evt) => handleSelectS(e, evt, "Eu Sector", "eu_sectors")} response={responseR} items={euSectors} />
        ) : (
            <TODIS_DROPDOWN title="SECTOR" handleSelect={(e, evt) => handleSelectS(e, evt, "Sector", "sectors")} response={responseR} items={sectors} />
        )}
    </Col>
    <Col lg={1} style={{ width: 'auto', paddingInline: "7px" }}>
        <TODIS_DATEPICKER handleDate={(data) => handleDate(data, "Years")} onlyYearPicker={true} placeholder="Years" />
    </Col>
    <Col lg={1} style={{ width: 'auto' }}>
        <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} icon={order ? BsSortDownAlt : BsSortDown} onclick={() => orderRequest(order)} />
    </Col>
    <Col lg={1} style={{ width: 'auto' }}>
        <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} icon={BsArrowClockwise} onclick={() => refreshRequest()} />
    </Col>
</Row>

{/* Tercera hilera */}
{(filterR["Regional Partner"]?.length > 0 || filterR["Type"]?.length > 0 || filterR["Sector"]?.length > 0 || filterR["Eu Sector"]?.length > 0 || filterR["transportType"]?.length > 0 || filterR["Status"]?.length > 0 || (filterR["Date"] != null) || (filter["fromDate"] != null))  && (
    <Row className="mb-2" style={{ gap: '10px 0' }}>
        <Col lg={3} style={{ width: 'auto' }}>
            <h6 style={{ fontSize: "0.9rem", cursor: "pointer" }}>
                <span onClick={() => removeAllFilterR()}>
                    <MdDelete size={18} color="red" className="me-1" />Remove Filter
                </span>
            </h6>
        </Col>
    </Row>
)}

                            </Row>
                        </Col>
                        <Col lg={12} className="ps-4 pt-4">
                            <Row className="float-start">
                                <Col lg={2} style={{ width: 'auto' }}>
                                    <h6>
                                        Regional Partner:
                                        {
                                            filterR["Regional Partner"].length != 0 ?
                                                filterR["Regional Partner"].map((item, index) => {
                                                    return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removefilterR("Regional Partner", "regionalPartner", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                })
                                                : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Regional Partner</Badge>
                                        }
                                    </h6>
                                </Col>
                                <Col lg={2} style={{ width: 'auto' }}>
                                    <h6>
                                        Status:
                                        {
                                            filterR["Status"].length != 0 ?
                                                filterR["Status"].map((item, index) => {
                                                    return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removefilterR("Status", "status", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                })
                                                : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Status</Badge>
                                        }
                                    </h6>
                                </Col>
                                <Col lg={2} style={{ width: 'auto' }}>
                                    <h6>
                                        Type:
                                        {
                                            filterR["Type"].length != 0 ?
                                                filterR["Type"].map((item, index) => {
                                                    return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removefilterR("Type", "projectType", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                })
                                                : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Type</Badge>
                                        }
                                    </h6>
                                </Col>
                                {/* <Col lg={2} style={{ width: 'auto' }}>
                                    <h6>
                                        Years:
                                        {filterR["Years"].length > 0 ? (
                                            filterR["Years"].map((year, index) => {
                                                console.log("Rendering year:", year); // Para ver qué año se está renderizando
                                                // Asegúrate de que year sea un string o un número
                                                return (
                                                    <Badge key={index} className={style.bgFilter}>
                                                        <span className={style.cursorPointer} onClick={() => removeFilterYear(year)}>
                                                            <BsX fontSize={16} color="#3e84b8" />
                                                        </span>
                                                        {year}
                                                    </Badge>
                                                );
                                            })
                                        ) : (
                                            <Badge className={style.bgFilter}>
                                                <BsCheck fontSize={16} color="#3e84b8" /> All Years
                                            </Badge>
                                        )}
                                    </h6>
                                </Col> */}
                                <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                                    <h6 style={{ fondSize: "0.8rem" }}>
                                        Years:
                                        {
                                            filterR["Years"] != null ?
                                                <Badge className={style.bgFilter}><span className={style.cursorPointer} onClick={() => removeFilterDate("Years")}><BsX fontSize={16} color="#3e84b8" /></span> {filterR["Years"]}</Badge>
                                                : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Years</Badge>
                                        }
                                    </h6>
                                </Col>

                                {isEuAcquis ?
                                <><Col lg={2} style={{ width: 'auto' }}>
                                    <h6 style={{ fontSize: "0.9rem" }}>
                                        Eu Acquis Sectors:
                                        {
                                            filterR["Eu Sector"].length != 0 ?
                                                filterR["Eu Sector"].map((item, index) => {
                                                    return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removefilterR("Eu Sector", "eu_sectors", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                })
                                                : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Eu Acquis Sectors</Badge>
                                        }
                                    </h6>
                                </Col></> : <>
                                <Col lg={2} style={{ width: 'auto' }}>
                                    <h6 style={{ fontSize: "0.9rem" }}>
                                        Sector:
                                        {
                                            filterR["Sector"].length != 0 ?
                                                filterR["Sector"].map((item, index) => {
                                                    return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removefilterR("Sector", "sectors", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                })
                                                : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Sector</Badge>
                                        }
                                    </h6>
                                </Col>
                                </>
                            }
                            </Row>
                        </Col>
                    </Row>
                    <Row className="todis-form-action-panel pb-3" style={{ overflow: "auto", maxHeight: "660px" }}>
                        {
                            !tasksNotFound && responseR ?
                                (requests.map((request) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} style={{ fontSize: "15px" }} key={request.id}><Container>
                                    <Row className="selectable-task">
                                        <Col lg={10}>

                                            {/* <h4 className="fw-bold" style={{ fontSize: "21px" }}>
                                                {getProjectTitle(request.transportType, request.regionalPartner, request.projectType)}
                                            </h4>
                                            <h5 style={{ display: "inline-block", fontSize: "14px", textAlign: "right" }}>Valid For: {request.validFor}</h5> */}

                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                <h4 className="fw-bold" style={{ fontSize: "21px" }}>
                                                    {getProjectTitle(request.transportType, request.regionalPartner, request.projectType)}
                                                </h4>
                                                <h5 style={{ display: "inline-block", fontSize: "14px", textAlign: "end" }}>
                                                    Valid For: {request.validFor}
                                                </h5>
                                            </div>
                                            <Row>
                                                <Col lg={1} style={{ paddingInline: "7px", width: "auto" }} >
                                                    <span><MdGrid3X3 size="18" color="#004494" /> {request.id}</span>
                                                </Col>
                                                {request.projectType != 'EU Acquis' && request.startNode && request.endNode && (
                                                    <>
                                                        <Col lg={2} className="w-auto">
                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node 1:</strong> {request.startNode}</span>
                                                        </Col>
                                                        <Col lg={2} className="w-auto">
                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node 2:</strong> {request.endNode}</span>
                                                        </Col>
                                                    </>
                                                )}
                                                {request.projectType == "EU Acquis" && (
                                                    <Col lg={2} className="w-auto">
                                                        <span><strong>Celex Number:</strong> {request.celexNumber}</span>
                                                    </Col>
                                                )}
                                                <Col lg={2} style={{ paddingInline: "7px", width: "auto" }}>
                                                    <span style={{ textTransform: "capitalize" }}><MdCircle size="18" className="me-1" color={statusClass(request.status)} /> {request.status}</span>
                                                </Col>
                                                <Col lg={2} style={{ paddingInline: "7px", width: "auto" }}>
                                                    <span><FaDatabase size="18" className="me-1" color="#004494" /> {request.projectType}</span>
                                                </Col>
                                                <Col lg={2} style={{ paddingInline: "7px", width: "auto" }}>
                                                    <span style={{ textTransform: "capitalize" }}><HiLocationMarker size="18" className="me-1" color="#004494" /> {request.regionalPartner}</span>
                                                </Col>
                                                <Col lg={3} style={{ paddingInline: "7px", width: "auto" }}>
                                                    <span><FaCalendar size="18" className="me-1" color="#004494" /> {request.date}</span>
                                                </Col>
                                                <Col>
                                                    <span style={{ textTransform: "capitalize" }}><BsPersonCircle size="20" className="me-1" color="#90959C" /> {request.assignedTo}</span>
                                                </Col>
                                                {request.transportType && request.transportType !== 'Transport Method' && (
                                                    <Col lg={2} className="w-auto">
                                                        <span>
                                                            {request.transportType === 'Roads' && <MdAirportShuttle size="20" color="#004494" />}
                                                            {request.transportType === 'Railways' && <MdTrain size="20" color="#004494" />}
                                                            {request.transportType === 'Airports' && <MdAirplanemodeActive size="20" color="#004494" />}
                                                            {request.transportType === 'Freight Terminal' && <MdAirplaneTicket size="20" color="#004494" />}
                                                            {request.transportType === 'Inland waterways' && <MdOutlineWater size="20" color="#004494" />}
                                                            {request.transportType === 'Seaports' && <MdDirectionsBoat size="20" color="#004494" />}
                                                            {request.transportType === 'Railways Border Crossings' && <MdRailwayAlert size="20" color="#004494" />}
                                                            {request.transportType === 'Roads Border crossings' && <MdAddRoad size="20" color="#004494" />}
                                                            {request.transportType === 'Inland waterway ports' && <MdHouseboat size="20" color="#004494" />}
                                                            {request.transportType}
                                                        </span>
                                                    </Col>
                                                )}
                                            </Row>
                                        </Col>
                                        <Col lg={2} className="p-0" style={{ alignSelf: "center" }}>
                                            <Row style={{ float: "right" }}>
                                                {permissions.some(item => item.id == 1) && <Col lg={6}>
                                                    <TODIS_BTN_SECUNDARY variant="primary" icon={MdVisibility} sizeIcon="20" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} onclick={() => navigate("/TODIS-APP/WorkFlow/request/" + request.id)} />
                                                </Col>}
                                                {permissions.some(item => item.id == 2) && <Col lg={6}>
                                                    <TODIS_BTN_PRIMARY variant="primary" icon={MdDelete} sizeIcon="20" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} onclick={() => deleteRequest(request.id)} />
                                                </Col>}
                                            </Row>
                                        </Col>
                                    </Row>
                                </Container></Col>))) : tasksNotFound ?
                                    <div className="h-100 d-flex justify-content-center align-items-center"> <div style={{ textAlign: "center" }}>
                                        <BsCloudSlashFill fontSize={100} color="#000000" />
                                        <h3 className="">Request Not found </h3>
                                    </div></div> :

                                    // loading requests 
                                    ([...Array(5)].map((request, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}><Container>
                                        <Row>
                                            <Col lg={10}>
                                                <Placeholder as="h4" animation="glow"><Placeholder xs={5} size="md" /></Placeholder>
                                                <Row>
                                                    <Col lg={1} >
                                                        <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                    </Col>
                                                    <Col lg={2} >
                                                        <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                    </Col>
                                                    <Col lg={2} >
                                                        <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                    </Col>
                                                    <Col lg={2} >
                                                        <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                    </Col>
                                                    <Col lg={2} >
                                                        <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                    </Col>
                                                    <Col lg={2}>
                                                        <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col lg={2} className="p-0">
                                                <Row>
                                                    <Col lg={6}>
                                                        <Placeholder.Button variant="light" xs={12} size="md" />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <Placeholder.Button variant="light" xs={12} size="md" />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Container></Col>)))
                        }
                    </Row>
                </Container>
            </Col>
            <SectionRequests refreshRequests={() => refreshRequest()} permissions={permissions} />
        </>
    );
}

export default Requests;